import { addItemToCollection } from "directus/src/operations";

// Add createProject function
export async function createExtension({ item }) {
  try {
    const query = {
      fields: [
        "job",
        "end_date",
        "justification",
      ],
    };

    const data = await addItemToCollection("job_extensions", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
